module.exports = __webpack_public_path__ + "media/img/logo-Marmalade-1cf651fa457b54a1a3caa8e1844df84a.svg";